import { Assignment } from '@mui/icons-material';
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { EntityType } from '@nohara-dxdev/mt-common';
import { permission } from '@nohara-dxdev/oidc-core';
import { OidcProtectedComponent, useScopeIds } from '@nohara-dxdev/react-oidc';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TasksList } from './tasks-list';

const readTaskPermissions = [permission.task.read];

export interface TasksButtonProps {
  entityId: string;
  entityType: EntityType;
  entityName: string;
}

export const TasksButton = ({ entityId, entityType, entityName }: TasksButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const scopeIds = useScopeIds();

  const subject = useMemo(
    () => ({
      ...scopeIds,
      entityId,
      entityType,
    }),
    [scopeIds, entityId, entityType],
  );

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <OidcProtectedComponent requireAll={readTaskPermissions} subject={subject}>
      <Tooltip title={t('tasks.view.tooltip', 'View tasks for {{entityName}}', { entityName })}>
        <IconButton size="small" onClick={handleOpen} color="primary">
          <Assignment fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          {t('tasks.view.title', 'Tasks for {{entityName}}', { entityName })}
        </DialogTitle>
        <DialogContent>
          <TasksList filters={{ entityId, entityType }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('common.close')}</Button>
        </DialogActions>
      </Dialog>
    </OidcProtectedComponent>
  );
};
